import MrtLastTouchReportVirtualized from "@/components/Table/MrtLastTouchReportVirtualized.tsx";
import { useEmployee } from "@/contexts/EmployeeProvider.tsx";
import { Stack, Typography } from "@mui/material";
import { type ReactNode, useEffect } from "react";

const ReportLastTouch = (): ReactNode => {
    const { hasPermission } = useEmployee();

    useEffect(() => {
        document.title = "Reports";
    }, []);

    if (!hasPermission("view:report-last-touch")) {
        return <div>You do not have access to this page.</div>;
    }

    return (
        <Stack
            sx={{
                flexGrow: 1,
                width: "100%",
                height: "100%",
                display: "flex",
            }}
        >
            <Typography variant="h4" mb={2}>
                Report: Last Client Contact
            </Typography>
            <MrtLastTouchReportVirtualized />
        </Stack>
    );
};

export default ReportLastTouch;
